






































import Vue from 'vue'
import Component from 'vue-class-component'
import CompanyDetailsHeader from './header/CompanyDetailsHeader.vue'
import GridFilter from '@/components/grids/companyDetails/filter/GridFilter.vue'
import { StoreActionTypes } from '@/store/types'
import GridComponent from '@/components/grids/companyDetails/list/GridComponent.vue'
import CreateCompanyEmployeeModalForm from '@/components/form/CreateCompanyEmployeeModalForm.vue'
import ActionButton from '@/components/lib/button/ActionButton.vue'
import ModalComponent from '@/components/modal/ModalComponent.vue'
import {CreateEmployeeRequestModel, CompanyModel} from '@/services/types'

const CompanyDetailsProps = Vue.extend({
	props: {
		companyId: {
			type: String,
			required: true,
			validator: function(value) {
				return Number.isInteger(parseInt(value))
			}
		}
		
	}
})

@Component({
	components: {
		CompanyDetailsHeader,
		GridFilter,
		GridComponent,
		CreateCompanyEmployeeModalForm,
		ActionButton,
		ModalComponent
	}
})
export default class CompanyDetails extends CompanyDetailsProps {
	componentClass = "CompanyDetails"
	showCreateNewCompanyEmployeeForm = false 

	mounted(){
		this.$store.dispatch(StoreActionTypes.SET_COMPANIES_SELECTED_COMPANY_WITH_USERS_LIST, this.companyId)
	}

    handleCreateNewCompanyEmployeeBtnClick() {
		this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_ERROR_MESSAGE_CLEAR);
        this.showCreateNewCompanyEmployeeForm = !this.showCreateNewCompanyEmployeeForm
    }

    async handleCreateNewCompanyEmployeeModalOkBtnClick() {
        const model: CreateEmployeeRequestModel = (this.$refs.createNewCompanyEmployeeForm as CreateCompanyEmployeeModalForm).getCreateEmployeeRequestModel()
        await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_EMPLOYEE_CREATE, model)
		await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_LIST)
		if (!this.$store.getters.getEmployeesErrorMessage) {
			this.handleCreateNewCompanyEmployeeBtnClick()
		}        
    }

	get createNewCompanyEmployeeFormDisabled (){
        return this.$store.getters.isEmployeesDataLoading
    }

	get loadData(): boolean {
		return (this.$store.getters.getCompaniesSelectedCompany as CompanyModel) == null
	}
}
